<template>
  <div></div>
</template>
<script>
import Service from "@/services";
import { mapState } from "vuex";
export default {
components: {},
data: () => ({
  order_id: null,
  isBusy: false,
  showPagination: false,
  currentPage: 1,
  perPage: 30,
  totalRows: 0,
  selected: [],
  search: "",
  filter: "",
  filterOn: [],
  pageOptions: [2, 5, 10, 15, 30, 50],
  sortBy: "",
  sortDesc: false,
  sortDirection: "asc",
  from: 1,
  to: 0,
  columns: [
    { label: "Name", key: "name", sortable: true },
    { label: "Ticket", key: "ticket", sortable: true },
    { label: "Role", key: "role", sortable: true },
    { label: "Type", key: "type", sortable: true },
    { label: "Consent", key: "consent", sortable: true },
    { label: "At", key: "at", sortable: true },
  ],
  stat:{
      Attendees :0,
      AttendeesPending: 0,
      AttendeesTotal: 0,
      CheckedIn: 0,
      CheckedinPercent :0,
      SelfRegistrationOnsite :0,
      SelfRegistrationOnsitePending :0
  }
}),
computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
watch: {},
mounted() {
  // this.order_id = this.$route.query.o;
  window.location.href = '/checkin/monitor'+ "?s=" + this.s + "&e=" + this.e;
},
}
</script>
